import React from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Lazy, Navigation, Pagination } from 'swiper';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { useGetDashboardEmptyLegs } from 'untils/hook/emptyLeg/emptyLeg.hook';
import { CustomPagination } from '../Home.style';
import Card from './Card';
import { flexGap } from 'untils/polyfill/flex';
import { motion } from 'framer-motion/dist/framer-motion';

SwiperCore.use([Lazy, Navigation, A11y, Pagination]);

const Container = styled.div`
  width: var(--home-section-width);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: var(--home-section-top-padding) 0;
  ${flexGap('30px')}

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: stretch;
    width: max-content;
    height: auto;
  }
`;

const EmptyLegBody = styled.div`
  width: 100%;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  ${flexGap('16px')}
  max-width: 572px;
`;

const TitleHeader = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
`;

const Tips = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #424748;
`;

const Desc = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 12px;
  color: #050a30;
`;

const ViewMoreLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: #050a30;
  width: 100px;
  height: 37px;
  border-radius: 4px;
  border: 1px solid #050a30;
  cursor: pointer;
  &:hover {
    color: #050a30;
  }
`;

const MotionBox = styled(motion.div)`
  background: #f4f6fc;
  border-radius: 4px;
  height: 100%;
  display: flex;
  align-items: stretch;
`;

const variant = {
  hover: {
    y: -8,
    boxShadow: '0px 4px 16px rgba(77, 100, 126, 0.4)',
    transition: { duration: 0.5 },
  },
};

const EmptyLegComponent = () => {
  const { isLoading, data } = useGetDashboardEmptyLegs();

  return (
    <Container>
      <Header>
        <Title>
          <div>
            <TitleHeader>Empty Leg Flight Offers</TitleHeader>
            <Tips>
              Save on discounted private jet charter flight offers and discover the
              <br /> convenience and comfort that you can only get on private charter flights.
            </Tips>
          </div>

          <Tips>Book while these private jet charter flights are  available.</Tips>
        </Title>
        <CustomPagination id="empty-pagination" />
        <ViewMoreLink href={'/emptyLeg'}>View more</ViewMoreLink>
      </Header>
      <EmptyLegBody>
        {isLoading && <div>Loading...</div>}
        {data && (
          <Swiper
            slidesPerView="3"
            lazy
            pagination={{
              renderCustom: function (_, current, total) {
                return `<span>${current}</span> / <span>${total}</span>`;
              },
              type: 'custom',
              el: '#empty-pagination',
            }}
          >
            {data.map((item) => {
              return (
                <SwiperSlide key={item.Id}>
                  <MotionBox variants={variant} whileHover="hover">
                    <Card item={item} />
                  </MotionBox>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </EmptyLegBody>
      <Desc>
        * All advertised charter private jet rates are net prices and are subject to taxes,
        regulatory fees, or
        <br /> other charges, which may vary based on routing and availability
      </Desc>
    </Container>
  );
};

export default EmptyLegComponent;
